import { requestPrice } from '../../api/propertyApi';
import { PROPERTY_EXTRA_RISKS } from '../../constants/propertyCalcConstants';
import { propertyTypes } from '../../containers/PropertyCalculatorContainer/options';
import { propertyPayloadSchema } from '../../validations/propertyCalcValidations';
import { PAYMENT_FREQUENCIES, SINGLE } from '../../constants/paymentFrequency';

const GET_PRICES = 'efes/propertyCalc/GET_PRICES';
const CLEAR_ALL_PRICES = 'efes/propertyCalc/CLEAR_ALL_PRICES';
const GET_PRICES_SUCCESS = 'efes/propertyCalc/GET_PRICES_SUCCESS';
const GET_PRICES_FAIL = 'efes/propertyCalc/GET_PRICES_FAIL';
const SET_EXTRA_RISK = 'efes/propertyCalc/SET_EXTRA_RISK';

const SET_PROPERTY_TYPE = 'efes/propertyCalc/SET_PROPERTY_TYPE';
const SET_USE_PURPOSE = 'efes/propertyCalc/USE_PURPOSE';
const SET_PROPERTY_AREA = 'efes/propertyCalc/PROPERTY_AREA';
const SET_PAYMENT_FREQUENCY = 'efes/propertyCalc/PAYMENT_FREQUENCY';

const CLEAR_CALCULATION = 'efes/propertyCalc/CLEAR_CALCULATION';

const CLEAR_PAYMENT_FREQUENCY = 'efes/propertyCalc/CLEAR_PAYMENT_FREQUENCY';

const getEmptyAmounts = () => ({
  stylingAndEngineeringEquipment: null,
  movableEstate: null,
  bearingStructures: null,
  civilLiability: null,
});

const getEmptyPrices = () => ({
  stylingAndEngineeringEquipment: null,
  movableEstate: null,
  bearingStructures: null,
  civilLiability: null,
});

const initialState = {
  propertyType: propertyTypes[0].value,
  usePurpose: null,
  propertyArea: '',
  paymentFrequency: PAYMENT_FREQUENCIES[SINGLE],
  amounts: getEmptyAmounts(),
  prices: getEmptyPrices(),
  isFetchingPrice: false,
  priceErrorCode: '',
  extraRisks: PROPERTY_EXTRA_RISKS,
  paymentFrequencies: {},
  paymentsSchedule: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PROPERTY_TYPE:
      return {
        ...state,
        propertyType: action.data,
      };
    case SET_USE_PURPOSE:
      return {
        ...state,
        usePurpose: action.data,
      };
    case SET_PROPERTY_AREA:
      return {
        ...state,
        propertyArea: action.data,
      };
    case SET_PAYMENT_FREQUENCY:
      return {
        ...state,
        paymentFrequency: action.data,
      };
    case GET_PRICES:
      return {
        ...state,
        isFetchingPrice: true,
        priceErrorCode: '',
      };
    case CLEAR_ALL_PRICES:
      return {
        ...state,
        amounts: getEmptyAmounts(),
        priceErrorCode: '',
      };
    case GET_PRICES_SUCCESS: {
      const errorMessage = action.result.errorCode || '';

      return {
        ...state,
        isFetchingPrice: false,
        amounts: !errorMessage ? action.result.riskAmounts : getEmptyAmounts(),
        paymentFrequencies: !errorMessage && {
          single: action.result.paymentsType.single,
          semiannual: action.result.paymentsType.semiannual,
          quarterly: action.result.paymentsType.quarterly,
          monthly: action.result.paymentsType.monthly,
        },
        paymentsSchedule: !errorMessage && {
          monthly: action.result.paymentsSchedule.monthly,
          semiannual: action.result.paymentsSchedule.semiannual,
          quarterly: action.result.paymentsSchedule.quarterly,
        },
        priceErrorCode: errorMessage,
      };
    }
    case GET_PRICES_FAIL:
      return {
        ...state,
        isFetchingPrice: false,
        priceErrorCode: '',
      };
    case SET_EXTRA_RISK:
      const { propertyType, key, checked } = action.data;

      return {
        ...state,
        extraRisks: {
          ...state.extraRisks,
          [propertyType]: {
            ...state.extraRisks[propertyType],
            [key]: checked,
          },
        },
      };
    case CLEAR_CALCULATION:
      return state;
    case CLEAR_PAYMENT_FREQUENCY:
      return {
        ...state,
        paymentFrequency: PAYMENT_FREQUENCIES[SINGLE],
      };
    default:
      return state;
  }
}

const createReducerWithName = (name) => (state = initialState, action) => {
  if (action.name !== name) {
    return state;
  }
  return reducer(state, action);
};

export const propertyCalculationReducerForContract = createReducerWithName(
  'contract',
);

export const setPropertyType = (data, name) => ({
  type: SET_PROPERTY_TYPE,
  data,
  name,
});

export const setUsePurpose = (data, name) => ({
  type: SET_USE_PURPOSE,
  data,
  name,
});

export const setPropertyArea = (data, name) => ({
  type: SET_PROPERTY_AREA,
  data,
  name,
});

export const setPaymentFrequency = (data, name) => ({
  type: SET_PAYMENT_FREQUENCY,
  data,
  name,
});

export const clearPaymentFrequency = (name) => ({
  type: CLEAR_PAYMENT_FREQUENCY,
  name,
});

export const setExtraRisk = (data, name) => ({
  type: SET_EXTRA_RISK,
  data,
  name,
});

export const clearCalculation = (name) => ({
  type: CLEAR_CALCULATION,
  name,
});

export const clearAllPrices = () => ({ type: CLEAR_ALL_PRICES });

export const getPrice = (data, name) => (dispatch) => {
  propertyPayloadSchema.isValid(data).then((isValid) => {
    if (isValid) {
      dispatch({
        actions: [
          { type: GET_PRICES, name },
          { type: GET_PRICES_SUCCESS, name },
          {
            type: GET_PRICES_FAIL,
            name,
            showError: true,
            customMsg: 'getPricesFail',
          },
        ],
        promise: requestPrice(data).then((response) => response.result),
      });
    }
  });
};
